import { render, staticRenderFns } from "./ResourceForm.vue?vue&type=template&id=c8ecfe00&scoped=true&"
import script from "./ResourceForm.vue?vue&type=script&lang=js&"
export * from "./ResourceForm.vue?vue&type=script&lang=js&"
import style0 from "./ResourceForm.vue?vue&type=style&index=0&id=c8ecfe00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ecfe00",
  null
  
)

export default component.exports